<div class="flex flex-col flex-auto min-w-0">
    <!-- Main -->
    <div class="border-t -mt-px">
        <div class="w-full max-w-screen-xl mx-auto">
            <div
                class="grid grid-cols-1 sm:grid-cols-4 gap-6 w-full min-w-0 p-5"
            >
                <!-- APR Exceed MAWOP Card -->
                <div
                    class="col-span-1 sm:col-span-2 bg-card shadow rounded-2xl overflow-hidden flex flex-col"
                >
                    <div class="row justify-between card-header px-6 py-3">
                        <div>
                            <div
                                class="text-lg font-medium tracking-tight leading-6 truncate"
                            >
                                APR MAWOP Status
                            </div>
                        </div>
                    </div>

                    <div class="p-6 flex flex-col h-full">
                        <!-- Description -->
                        <p class="text-gray-600 text-sm mb-3">
                            Strings exceeding HTL (80% MAWOP Limit)
                        </p>

                        <!-- Overall Status Section -->
                        <div class="mb-2">
                            <div class="text-6xl font-bold text-gray-950">
                                {{
                                    aprExceedMawopData?.totalStringsExceedingMawop ||
                                        0
                                }}
                            </div>
                        </div>

                        <!-- Divider -->
                        <div class="border-t border-gray-200 my-4"></div>

                        <!-- Breakdown Stack (Vertical) -->
                        <div class="flex flex-col gap-4 mt-auto">
                            @for (
                                aprItem of aprExceedMawopData?.fields;
                                track $index
                            ) {
                                <!-- General -->
                                <div class="flex items-center justify-between">
                                    <p class="text-gray-600 text-sm">
                                        {{ aprItem.name }}
                                    </p>
                                    <div
                                        class="text-3xl font-bold text-gray-950"
                                    >
                                        {{ aprItem.count || 0 }}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <!-- Annulus MAWOP Distribution (Bar) - Right -->
                <div
                    class="col-span-1 sm:col-span-2 bg-card shadow rounded-2xl overflow-hidden"
                >
                    <div class="row justify-between card-header px-6 py-3">
                        <div
                            class="text-lg font-medium tracking-tight leading-6 truncate"
                        >
                            Annulus MAWOP Distribution
                        </div>
                    </div>
                    <div class="flex flex-col">
                        <!-- Description -->
                        <p class="text-gray-600 text-sm ml-6 mt-6">
                            Strings exceeding HTL (80% MAWOP Limit) by Category
                        </p>
                        <div class="flex justify-center items-center p-4">
                            <div
                                id="aprManagementBarChart"
                                class="h-52 w-full"
                            ></div>
                        </div>
                        <!-- Annulus Count Grid -->
                        <div class="border-t border-gray-200 p-6">
                            <div class="grid grid-cols-4 gap-4">
                                <!-- Annulus A -->
                                <div class="flex flex-col items-center">
                                    <div
                                        class="flex items-center justify-center w-16 h-16 rounded-md bg-blue-100 text-blue-600 text-2xl font-bold mb-2"
                                    >
                                        {{
                                            annulusExceedMawopData?.totalAnnulusAExceeding ||
                                                0
                                        }}
                                    </div>
                                    <p class="text-gray-600 text-sm">
                                        Annulus A
                                    </p>
                                </div>

                                <!-- Annulus B -->
                                <div class="flex flex-col items-center">
                                    <div
                                        class="flex items-center justify-center w-16 h-16 rounded-md bg-emerald-100 text-emerald-600 text-2xl font-bold mb-2"
                                    >
                                        {{
                                            annulusExceedMawopData?.totalAnnulusBExceeding ||
                                                0
                                        }}
                                    </div>
                                    <p class="text-gray-600 text-sm">
                                        Annulus B
                                    </p>
                                </div>

                                <!-- Annulus C -->
                                <div class="flex flex-col items-center">
                                    <div
                                        class="flex items-center justify-center w-16 h-16 rounded-md bg-amber-100 text-amber-600 text-2xl font-bold mb-2"
                                    >
                                        {{
                                            annulusExceedMawopData?.totalAnnulusCExceeding ||
                                                0
                                        }}
                                    </div>
                                    <p class="text-gray-600 text-sm">
                                        Annulus C
                                    </p>
                                </div>

                                <!-- Annulus D -->
                                <div class="flex flex-col items-center">
                                    <div
                                        class="flex items-center justify-center w-16 h-16 rounded-md bg-rose-100 text-rose-600 text-2xl font-bold mb-2"
                                    >
                                        {{
                                            annulusExceedMawopData?.totalAnnulusDExceeding ||
                                                0
                                        }}
                                    </div>
                                    <p class="text-gray-600 text-sm">
                                        Annulus D
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- MAWOP Exceed Data Dashboard - Premium Redesign -->
                <div class="sm:col-span-4 lg:col-span-4">
                    <div
                        class="grid grid-cols-1 sm:grid-cols-2 gap-6 w-full min-w-0"
                    ></div>
                </div>

                <div
                    class="sm:col-span-4 lg:col-span-4 bg-card shadow rounded-2xl overflow-hidden"
                >
                    <!-- Card Header -->
                    <div
                        class="card-header px-6 py-3 border-b border-gray-200 flex items-center justify-between gap-4"
                    >
                        <div class="min-w-0">
                            <div
                                class="text-lg font-medium tracking-tight leading-6 truncate"
                            >
                                Annulus Pressure Analysis
                            </div>

                            <div
                                class="text-sm text-gray-300 truncate mt-1"
                                *ngIf="selectedNode"
                            >
                                {{ selectedNode }}
                            </div>
                        </div>

                        <div class="flex items-center gap-3 ml-auto">
                            <label
                                for="aprYearInput"
                                class="text-xs text-gray-300"
                                >Year</label
                            >
                            <div class="apr-year-input-wrapper">
                                <input
                                    id="aprYearInput"
                                    type="text"
                                    inputmode="numeric"
                                    maxlength="4"
                                    placeholder="All"
                                    class="apr-year-input"
                                    [ngModel]="yearInputValue"
                                    [ngModelOptions]="{ standalone: true }"
                                    (ngModelChange)="yearInputValue = $event"
                                    (keydown.enter)="
                                        applyYearInput(yearInputValue)
                                    "
                                />
                                <button
                                    type="button"
                                    class="apr-year-search-btn"
                                    (click)="applyYearInput(yearInputValue)"
                                    aria-label="Search year"
                                    matTooltip="Apply year filter"
                                >
                                    <mat-icon class="icon-size-4"
                                        >search</mat-icon
                                    >
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Card Content -->
                    <div class="p-6">
                        <div class="grid grid-cols-1 sm:grid-cols-4 gap-6">
                            <!-- Platform Selection Panel -->
                            <div class="bg-gray-50 rounded-lg p-4">
                                <div class="flex items-center mb-4">
                                    <mat-icon class="text-gray-600 mr-2"
                                        >account_tree</mat-icon
                                    >
                                    <h3
                                        class="text-base font-semibold text-gray-900"
                                    >
                                        Platform Selection
                                    </h3>
                                </div>
                                <div
                                    class="overflow-auto rounded h-full max-h-[95vh]"
                                >
                                    <mat-tree
                                        [dataSource]="dataSource"
                                        [treeControl]="treeControl"
                                        class="rounded bg-gray-50"
                                    >
                                        <!-- Leaf node template for well strings (last child) -->
                                        <mat-tree-node
                                            *matTreeNodeDef="let node"
                                            matTreeNodePadding
                                        >
                                            <!-- Well String name -->
                                            <button
                                                class="flex items-center gap-2 w-full text-left py-2 px-3 rounded-lg hover:border-gray-200 hover:bg-gray-100 transition-all duration-200"
                                                (click)="
                                                    openGraph(
                                                        node.id,
                                                        node.nodeLevel
                                                    )
                                                "
                                                [ngClass]="{
                                                    'border border-gray-200 bg-gray-100 text-blue-900 font-medium':
                                                        node.name ==
                                                        selectedNode,
                                                    'text-gray-700':
                                                        node.name !=
                                                        selectedNode,
                                                }"
                                            >
                                                <mat-icon
                                                    class="icon-size-4 mr-2"
                                                    *ngIf="
                                                        node.nodeLevel ===
                                                        'Platform'
                                                    "
                                                >
                                                    oil_barrel
                                                </mat-icon>
                                                <mat-icon
                                                    class="icon-size-4 mr-2"
                                                    *ngIf="
                                                        node.nodeLevel ===
                                                        'WellString'
                                                    "
                                                >
                                                    pipe
                                                </mat-icon>
                                                {{ node.name }}
                                            </button>
                                        </mat-tree-node>
                                        <!-- This is the tree node template for expandable nodes -->
                                        <mat-tree-node
                                            *matTreeNodeDef="
                                                let node;
                                                when: hasChild
                                            "
                                            matTreeNodePadding
                                        >
                                            <button
                                                mat-icon-button
                                                matTreeNodeToggle
                                                [attr.aria-label]="
                                                    'toggle ' + node.name
                                                "
                                                class="flex items-center !w-8 !h-8 !min-w-8 !min-h-8 !rounded-full mr-2"
                                            >
                                                <mat-icon class="icon-size-4">
                                                    {{
                                                        treeControl.isExpanded(
                                                            node
                                                        )
                                                            ? "expand_more"
                                                            : "chevron_right"
                                                    }}
                                                </mat-icon>
                                            </button>
                                            <!-- Parent name -->
                                            <span
                                                class="flex items-center gap-2 font-medium text-gray-800"
                                            >
                                                <mat-icon
                                                    class="icon-size-4"
                                                    *ngIf="
                                                        node.nodeLevel ===
                                                        'Field'
                                                    "
                                                    svgIcon="custom:platform"
                                                ></mat-icon>
                                                <mat-icon
                                                    class="icon-size-4"
                                                    *ngIf="
                                                        node.nodeLevel ===
                                                        'Platform'
                                                    "
                                                >
                                                    oil_barrel
                                                </mat-icon>
                                                {{ node.longName }}
                                            </span>
                                        </mat-tree-node>
                                    </mat-tree>
                                </div>
                            </div>

                            <!-- Chart Panel with Tabs -->
                            <div
                                class="col-span-3 border rounded-lg overflow-hidden"
                            >
                                <mat-tab-group
                                    [(selectedIndex)]="selectedTabIndex"
                                    (selectedIndexChange)="onTabChanged($event)"
                                    class="h-full"
                                >
                                    <!-- Details Tab -->
                                    <mat-tab label="Details">
                                        <div
                                            class="py-4 border-b border-gray-200 text-right"
                                        >
                                            <div
                                                class="inline-flex items-center px-3 py-1 rounded-md bg-gray-100 text-md text-gray-700"
                                                *ngIf="selectedNode"
                                            >
                                                <span class="font-medium"
                                                    >Well:</span
                                                >
                                                <span class="ml-1">{{
                                                    selectedNode
                                                }}</span>
                                            </div>
                                        </div>
                                        <div
                                            class="grid grid-cols-1 lg:grid-cols-2 gap-0 w-full"
                                            *ngIf="
                                                annulusPressureCharts.length > 0
                                            "
                                        >
                                            <!-- Individual Series Charts -->
                                            <div
                                                *ngFor="
                                                    let chart of annulusPressureCharts;
                                                    let i = index
                                                "
                                                class="px-4 pt-4"
                                                [ngClass]="{
                                                    'border-r border-gray-200':
                                                        (i + 1) % 2 === 1 &&
                                                        annulusPressureCharts.length >
                                                            i + 1,
                                                    'border-b border-gray-200':
                                                        i <
                                                        annulusPressureCharts.length -
                                                            2,
                                                }"
                                            >
                                                <div class="mb-4">
                                                    <h3
                                                        class="text-sm font-semibold text-gray-900"
                                                    >
                                                        {{ chart.name }}
                                                    </h3>
                                                </div>
                                                <div
                                                    [id]="'seriesChart-' + i"
                                                    class="w-full h-72"
                                                ></div>
                                            </div>
                                        </div>

                                        <!-- No Data Message -->
                                        <div
                                            class="flex items-center justify-center h-96 text-gray-500 text-lg"
                                            *ngIf="
                                                annulusPressureCharts.length ===
                                                0
                                            "
                                        >
                                            No data available
                                        </div>
                                    </mat-tab>

                                    <!-- Overall Tab -->
                                    <mat-tab label="Overall">
                                        <div class="p-4">
                                            <div
                                                class="flex items-center justify-between mb-4"
                                            >
                                                <div class="flex items-center">
                                                    <mat-icon
                                                        class="text-gray-600 mr-2"
                                                        >show_chart</mat-icon
                                                    >
                                                    <h3
                                                        class="text-base font-semibold text-gray-900"
                                                    >
                                                        Pressure Trends
                                                    </h3>
                                                </div>
                                                <div
                                                    class="inline-flex items-center px-3 py-1 rounded-md bg-gray-100 text-md text-gray-700"
                                                    *ngIf="selectedNode"
                                                >
                                                    <span class="font-medium"
                                                        >Well:</span
                                                    >
                                                    <span class="ml-1">{{
                                                        selectedNode
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="relative">
                                                <div
                                                    id="chartdiv"
                                                    class="w-full h-[80vh]"
                                                ></div>
                                            </div>
                                        </div>
                                    </mat-tab>
                                </mat-tab-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
